<template>
  <company-toba-additive-form
    v-model="model"
    ref="form"
    :loading="loading"
    @deleteToba="confirmDeleteToba"
  />
</template>

<script>
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import CompanyTobaAdditiveForm from './CompanyTobaAdditiveForm';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';

export default {
  name: 'CompanyTobas',
  components: {
    CompanyTobaAdditiveForm
  },
  mixins: [SaveModelMixin, ViewModelMixin, NotificationMixin, CanAccessMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.companyToba,
      entity: 'Section Ancestors',
      componentAccess: {
        canCreate: {
          route: 'company.tobas.create',
          access: false
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    showAddButton() {
      return this.componentAccess.canCreate.access;
    }
  },
  mounted() {
    this.$EventBus.$on('company-tobas:deleted', () => {
      this.fetch();
    });
  },
  methods: {
    async fetch() {
      try {
        const { data } = await this.$api.companies.relationship(
          'tobas',
          this.id
        );

        this.model = {
          id: this.id,
          tobas: data.data
        };
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve TOBAs. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    confirmDeleteToba(model) {
      const deleteToba = async () => {
        try {
          await this.$api.companyToba.delete(model.id);
          this.$EventBus.$emit('company-tobas:deleted', model.id);
          this.$vs.notify({
            color: 'success',
            title: 'TOBA Deleted',
            position: 'top-right',
            text: 'The selected TOBA was successfully deleted'
          });
        } catch (e) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error occurred',
            text: 'Not able to delete TOBA. Please try again.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-right'
          });
        }
      };

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this TOBA`,
        accept: deleteToba,
        acceptText: 'Delete'
      });
    }
  }
};
</script>
<style lang="scss">

.note-field {
  display: flex;
  align-items: baseline;
  padding: 1rem !important;
  background-color: #f4f7fb;
  margin-bottom: 0 !important;

  label > span {
    color: #262626 !important;
    font-size: 15px !important;
  }

  .field-wrap {
    margin-left: 5px;
    width: 100%;

    #note {
      background-color: initial;
      opacity: 0.6;
    }
  }
}
</style>
